module.exports = __webpack_public_path__ + "static/media/bannerVideo720.2c9d4b7.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/video/bannerVideo720.mp4
// module id = /ykt
// module chunks = 1